import API from "../../Common/API"

export async function getStoreDetailsById (storeId){
    try{
        const response = await API.get(`/accounts/getAccountDetailsById/${storeId}`)
        return response.data
    }catch(err){
        return err
    }
}

export async function getStoreProducts(storeId){
    try{
        const response = await API.get(`/products/getStoreProductsById/${storeId}`);
        return response.data
    }catch(err){
        return err
    }
}